export default __webpack_public_path__ + "1a3b9a757aaee11f5fc538076d0cd5be.svg";